import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Copy, Box, Flex, Input, Label } from '@elparking/components'
import { injectIntl } from 'react-intl'
import moment from 'moment'
import messages from './messages'

export const internalFormat = 'YYYY-M-D'
export const getDate = (date) => (date && date.YYYY && date.MM && date.DD) ? `${date.YYYY.padStart(4, '0')}-${date.MM.padStart(2, '0')}-${date.DD.padStart(2, '0')}` : undefined
const Date = ({ onChange, separator, max, intl, defaultValue, value, valid, label, ...restProps }) => {
    const [date, setDate] = useState(defaultValue || value)
    const localFormat = moment.localeData().longDateFormat('L')
    const format = localFormat.split(/[^\w]/)
    const maxValue = max || moment().format(internalFormat)

    return <Box>
        <Box display={['block', 'none', 'none']}>
            <Input
              onChange={(value) => {
                const newDate = value && moment(value, internalFormat)
                const formatDate = value && {
                    DD: newDate.format('DD'),
                    MM: newDate.format('MM'),
                    YYYY: newDate.format('YYYY'),
                }
                setDate(formatDate)
                onChange(formatDate)
              }}
              type='date'
              label={label}
              format={localFormat.toLocaleLowerCase()}
              max={maxValue}
              value={getDate(date)}
              dataTest={`date_mobile`}
              valid={valid}
              defaultActive/>
        </Box>
        <Box display={['none', 'block', 'block']} width='100%'>
            {label && <Label>{label}</Label>}
            <Flex justifyContent='center' flexGrip='5px'>
                {format.map((type, index) => {
                    const desktopInputProps = (index === 0) ? restProps : {}
                    return <Box key={type} width='100%'>
                        <Flex alignItems='center'>
                            <Input
                              {...desktopInputProps}
                              textAlign='center'
                              label={null}
                              width='100%'
                              maxLength={type.length}
                              onChange={(value) => {
                                const newDate = {...date}
                                newDate[type] = value
                                setDate(newDate)
                                onChange(newDate)
                              }}
                              value={date[type] ? `${date[type]}` : undefined}
                              dataTest={`date_${type}`}
                              placeholder={intl.formatMessage(messages[type])}
                              valid={valid}/>
                            { ((index + 1) !== format.length) && separator }
                        </Flex>
                    </Box>
                })}
            </Flex>
        </Box>
    </Box>
}

Date.propTypes = {
    onChange: PropTypes.func,
    intl: PropTypes.object,
    separator: PropTypes.node,
    max: PropTypes.string,
    defaultValue: PropTypes.shape({
        MM: PropTypes.any,
        YYYY: PropTypes.any,
        DD: PropTypes.any,
    }),
    value: PropTypes.shape({
        MM: PropTypes.any,
        YYYY: PropTypes.any,
        DD: PropTypes.any,
    }),
    valid: PropTypes.bool,
    label: PropTypes.node,
}

Date.defaultProps = {
    separator: <Copy fontColor='gray' fontSize='large' fontWeight='light'> / </Copy>,
    onChange: () => {},
    value: {
        MM: undefined,
        YYYY: undefined,
        DD: undefined,
    },
}

export default injectIntl(Date)
